/* istanbul ignore file */
import React from 'react';

import { isSuperAdmin } from '@lumapps/permissions';
import { useSelector } from '@lumapps/redux/react';
import { BackOfficeStore } from '@lumapps/redux/types';

import {
    CustomerSettingsSideNavigation as CustomerSettingsSideNavigationComponent,
    CustomerSettingsSideNavigationProps,
} from './CustomerSettingsSideNavigation';

type ConnectedCustomerSettingsSideNavigationProps = Omit<CustomerSettingsSideNavigationProps, 'isAllowed'>;

export const CustomerSettingsSideNavigation: React.FC<ConnectedCustomerSettingsSideNavigationProps> = (props) => {
    const isAllowed = useSelector((state: BackOfficeStore) => isSuperAdmin(state));

    return <CustomerSettingsSideNavigationComponent {...props} isAllowed={isAllowed} />;
};

CustomerSettingsSideNavigation.displayName = 'CustomerSettingsSideNavigationConnected';
